import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCallBellFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.31 18.28C1.11 18.08 1 17.82 1 17.54C1 17.26 1.11 16.99 1.31 16.8C1.51 16.6 1.77 16.49 2.05 16.49H2.5V15.29C2.5 12.96 3.38 10.71 4.96 9C6.48 7.35 8.53 6.31 10.75 6.06V5.1H9.55C9.27 5.1 9 4.99 8.81 4.79C8.61 4.59 8.5 4.33 8.5 4.05C8.5 3.77 8.61 3.5 8.81 3.31C9.01 3.12 9.27 3 9.55 3H14.05C14.33 3 14.6 3.11 14.79 3.31C14.99 3.51 15.1 3.77 15.1 4.05C15.1 4.33 14.99 4.6 14.79 4.79C14.59 4.99 14.33 5.1 14.05 5.1H12.85V6.06C15.07 6.31 17.13 7.36 18.64 9C20.12 10.61 20.98 12.68 21.09 14.86V15.3L21.1 16.5H21.55C21.83 16.5 22.1 16.61 22.29 16.81C22.49 17.01 22.6 17.27 22.6 17.55C22.6 17.83 22.49 18.1 22.29 18.29C22.09 18.49 21.83 18.6 21.55 18.6H2.05C1.77 18.6 1.5 18.49 1.31 18.29V18.28ZM21.55 19.49H2.05C1.77 19.49 1.5 19.6 1.31 19.8C1.11 20 1 20.26 1 20.54C1 20.82 1.11 21.09 1.31 21.28C1.51 21.48 1.77 21.59 2.05 21.59H21.55C21.83 21.59 22.1 21.48 22.29 21.28C22.49 21.08 22.6 20.82 22.6 20.54C22.6 20.26 22.49 19.99 22.29 19.8C22.09 19.6 21.83 19.49 21.55 19.49Z",
		fill: "currentColor"
	})
});
export default SvgCallBellFilled;
